import { Component, OnInit, ViewChild } from '@angular/core';
import { InventoryService } from '../../../../services/inventory.service';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { HelpersService } from '../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { Paginator } from 'primeng/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateJobcardComponent } from '../../../modals/update-jobcard/update-jobcard.component';
import { NewJobcardService } from '../../../../services/new-jobcard.service';

@Component({
  selector: 'app-inventory-audit',
  templateUrl: './inventory-audit.component.html',
  styleUrls: ['./inventory-audit.component.scss'],
})
export class InventoryAuditComponent implements OnInit {
  public page = 1;
  public limit = 100;
  public skusearch = '';
  public jobcardno = '';
  public inventoryData: any = [];
  public totalRecords = 0;
  public busy = false;
  public loading = false;
  public countryData: any = {};

  public columns: any = [
    {
      header: this.translate.instant('bikeshop.inventory_audit.jobcard_no'),
      field: 'jobCardID',
      type: 'jobcardno',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.customer'),
      field: 'customer',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.bike'),
      field: 'bike',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.sku'),
      field: 'sku',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.product_name'),
      field: 'productName',
      type: 'string',
    },
    //{ header: this.translate.instant('bikeshop.inventory_audit.quantity'), field: 'quantity', type: 'string' },
    {
      header: this.translate.instant('bikeshop.inventory_audit.stock_changed'),
      field: 'stockChanged',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.action'),
      field: 'action',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.date'),
      field: 'createdDate',
      type: 'date',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.status'),
      field: 'statusID',
      type: 'status',
    },
  ];

  constructor(
    private inventoryService: InventoryService,
    public helperService: HelpersService,
    private translate: TranslateService,
    public serviceRequest: ServiceRequestService,
    public modalService: NgbModal,
    public router: Router,
    public route: ActivatedRoute,
    public newJobcardService: NewJobcardService,
  ) {}

  @ViewChild('paginator') paginator: Paginator;

  ngOnInit() {
    this.countryData = this.helperService.getCountryData();
    this.route.queryParams.subscribe((params) => {
      if (params['skusearch']) {
        this.skusearch = params['skusearch'];
      }
      if (params['jobcardno']) {
        this.jobcardno = params['jobcardno'];
      }
    });

    this.getInventoryAudit(() => {});
  }

  getInventoryAudit(callback) {
    this.busy = true;
    this.inventoryService
      .getInventoryAudit(
        this.helperService.getPartnerId(),
        this.page,
        this.limit,
        this.skusearch,
        this.jobcardno,
      )
      .subscribe(
        (results) => {
          this.inventoryData = results.inventoryItems
            ? results.inventoryItems
            : [];
          this.totalRecords = results.totalRecords;
          this.busy = false;
          callback();
        },
        (err) => {
          this.busy = false;
          this.inventoryData = [];
          this.totalRecords = 0;
          callback();
        },
      );
  }

  paginate(event) {
    this.page = event.page + 1;
    this.limit = event.rows;
    this.getInventoryAudit(() => {});
  }

  getStatusDescription(statusID) {
    switch (statusID) {
      case 1:
        return this.translate.instant(
          'bikeshop.inventory_audit.statuses.unprocessed',
        );
        break;
      case 2:
        return this.translate.instant(
          'bikeshop.inventory_audit.statuses.error_processing_transaction',
        );
        break;
      case 5:
        return this.translate.instant(
          'bikeshop.inventory_audit.statuses.being_processed',
        );
        break;
      case 10:
        return this.translate.instant(
          'bikeshop.inventory_audit.statuses.processed',
        );
        break;
      case 100:
        return this.translate.instant(
          'bikeshop.inventory_audit.statuses.non_inventory_item',
        );
        break;
    }
    return this.translate.instant('bikeshop.inventory_audit.statuses.unknown');
  }

  searchInventory() {
    this.page = 1;
    this.getInventoryAudit(() => {
      this.paginator.changePageToFirst({ page: 0, rows: this.limit } as any);
    });
  }

  openJobCard(jobcardID) {

    if (this.helperService.getPartnerData().UseNewJobCard) {
      this.newJobcardService.openManageJobCard(jobcardID, {
        onRefreshEvents: () => { 
          this.getInventoryAudit(() => {});
        }
      });

      return;
    }


    this.serviceRequest
      .getServiceRequestData(jobcardID)
      .subscribe((jobcard) => {
        const modalRef = this.modalService.open(UpdateJobcardComponent, {
          size: 'lg',
          backdrop: 'static',
          windowClass: 'jobcard-modal',
        });
        modalRef.componentInstance.jobcard = jobcard;
        modalRef.componentInstance.partnerID =
          this.helperService.getPartnerId();
        modalRef.result.then(
          (result) => {
            this.getInventoryAudit(() => {});
          },
          (onrejected) => {
            this.getInventoryAudit(() => {});
          },
        );
      });
  }

  abs(value) {
    return Math.abs(value);
  }
}
